module.exports = {"TXTCLI_Play_Now":{"id":"TXTCLI_Play_Now","defaultMessage":"Jetzt spielen","track":"Play Now"}}